import { BoardStatusEnum } from "enums/BoardStatusEnum";
import { BoardSettingsModel } from "models/BoardSettingsModel";
import { PatchBoardModel } from "models/PatchBoardModel";
import { UserLookupModel } from "models/UserLookupModel";
import { createContext } from "react";
import { UseFormReturn } from "react-hook-form";

export interface EditBoardPropertiesFieldValues {
  name: string;
  shortName: string;
  longName: string;
  description: string;
  status: BoardStatusEnum;
  businessOwner?: UserLookupModel;
  organisationUnit: string;
  edecideId: string;
}

export function getEditBoardPropertiesFieldValues(
  board: BoardSettingsModel | undefined
): EditBoardPropertiesFieldValues {
  return {
    name: board?.name ?? "",
    shortName: board?.shortName ?? "",
    longName: board?.longName ?? "",
    description: board?.description ?? "",
    status: board?.status ?? BoardStatusEnum.Draft,
    businessOwner: board?.businessOwner ?? undefined,
    organisationUnit: board?.organisationUnit ?? "",
    edecideId: board?.edecideId ?? "",
  };
}

export interface EditBoardPropertiesContextProps {
  confirmUnsaved: boolean;
  setConfirmUnsaved: (value: boolean) => void;
  isDirty: boolean;
  isValid: boolean;
  isLoading: boolean;
  isSubmittable: boolean;
  isSubmitting: boolean;
  form: UseFormReturn<EditBoardPropertiesFieldValues>;
  getPatch: (values: EditBoardPropertiesFieldValues) => PatchBoardModel;
  handleSave: () => Promise<void>;
  handleClose: (ignoreDirty?: boolean) => void;
  openEditBoardProperties: (boardSettings: BoardSettingsModel) => void;
}

export const EditBoardPropertiesContext = createContext({} as EditBoardPropertiesContextProps);
